<template>
  <CRow v-if="showCarTracking" class="m-0 p-0" style="height: 100vh">
    <!-- --------------------------------------------------------------------------------- sidebar -->
    <CCol
      v-show="showStatistics"
      class="bg-gray-300 col-sm-6 col-md-4 col-lg-3 m-0 p-0"
      style="
        width: 350px;
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
        direction: ltr !important;
      "
    >
      <!-- ------------------------------------------- آرم -->
      <CRow class="bg-gray-600 p-1 m-2 rounded">
        <!-- <CImg
          src="../../../img/icon.png"
          class="col-4"
          align="center"
          style="width: 65px"
        ></CImg> -->
        <CImg
          src="../../../img/ictcenter1.png"
          class="col-11"
          align="center"
        ></CImg>
      </CRow>

      <!-- ------------------------------------------- اطلاعات کاربری -->
      <CRow class="bg-gray-700 m-2 p-1 rounded" style="direction: rtl">
        <h5 class="text-center text-dark">اطلاعات کاربری</h5>

        <span
          ><CIcon name="cil-car-alt" width="25" class="text-dark" />
          {{ info.carName }}
        </span>

        <span class="mt-1"
          ><CIcon name="cif-ir" width="25" />
          {{ info.carPlate.substring(6) }}
          {{ info.carPlate.substring(3, 6) }}
          {{ info.carPlate.substring(2, 3) }}
          {{ info.carPlate.substring(0, 2) }}
        </span>

        <span class="mt-1"
          ><CIcon name="cil-user" width="25" class="text-dark" />
          {{ info.driverName }}</span
        >

        <span class="mt-1"
          ><CIcon name="cil-clock" width="25" class="text-dark" />
          {{ info.dateTime }}</span
        >

        <CRow class="justify-content-center m-0 mt-2">
          <CButton class="col-6 p-0">
            <CBadge color="danger" class="ml-2 position-static col-12"
              ><CIcon
                name="cil-bell"
                width="30"
                class="text-light mx-1"
                size="lg"
              />4</CBadge
            ></CButton
          >

          <CButton class="col-6 p-0"
            ><CBadge color="primary" class="ml-2 position-static col-12"
              ><CIcon
                name="cil-comment-square"
                width="30"
                class="text-light mx-1"
                size="lg"
              />4</CBadge
            >
          </CButton>

          <CButton class="col-12 btn-warning mt-1" @click="reportModal = true"
            ><CIcon
              name="cil-spreadsheet"
              width="30"
              class="text-light mx-1"
              size="lg"
            />گزارش گیری
          </CButton>
        </CRow>
      </CRow>

      <!-- ------------------------------------------- اطلاعات پایه -->
      <CRow class="bg-gray-700 m-2 p-1 rounded" style="direction: rtl">
        <h5 class="text-center text-dark">اطلاعات پایه</h5>

        <span class="mt-1"
          ><CIcon name="cil-lan" size="lg" class="text-dark" /> شبکه
          {{ info.networkType }}</span
        >
        <span>
          <CIcon name="cil-signal-cellular-3" size="lg" class="text-dark" />
          قدرت سیگنال {{ info.signalPower }}%
        </span>

        <span class="mt-1"
          ><CIcon name="cil-sim" size="lg" class="text-dark" /> سیم کارت
          {{ info.simCardPresence }}</span
        >

        <span class="mt-1">
          <CIcon name="cil-money" size="lg" class="text-dark" />
          شارژ مانده {{ info.SimcardBalance }} ریال</span
        >

        <span class="mt-1">
          <CIcon name="cil-battery-3" size="lg" class="text-dark" />
          شارژ باتری {{ info.battery }}%</span
        >

        <span class="mt-1"
          ><CIcon name="cil-input-power" size="lg" class="text-dark" /> برق
          دستگاه {{ info.powerState }}</span
        >
      </CRow>

      <!-- ------------------------------------------- اطلاعات نمایشی -->
      <CRow class="bg-gray-700 m-2 p-1 rounded" style="direction: rtl">
        <h5 class="text-center text-dark">اطلاعات نمایشی</h5>

        <CInputCheckbox
          label="محدودیت ها (مکانی)"
          class="mr-3 mb-2"
          :checked="info.limits"
          @change="setLimits($event)"
        />

        <CInputCheckbox
          label="توقف ها"
          class="mr-3 mb-2"
          :checked="info.stop"
          @change="setStop($event)"
        />

        <CInputCheckbox
          label="خروج از محدوده"
          class="mr-3 mb-2"
          :checked="info.active"
          @change="setActive($event)"
        />
      </CRow>

      <!-- ------------------------------------------- نمودار -->
      <CRow
        class="bg-gray-700 mx-2 mt-2 p-1 rounded"
        style="direction: rtl; height = 250px"
        @click="largeChart('dis/gas')"
      >
        <h5 class="text-center text-dark">اطلاعات آماری</h5>

        <CChartBar
          :datasets="defaultDatasets"
          :options="defaultOptions"
          :labels="month"
          class="bg-light rounded p-1 mt-1"
        />
      </CRow>

      <CRow
        class="bg-gray-700 mx-2 p-1 rounded"
        style="direction: rtl; height = 250px"
        @click="largeChart('speed')"
      >
        <!-- <h5 class="text-center text-dark">اطلاعات آماری</h5> -->

        <CChartLine
          :datasets="defaultDatasets2"
          :labels="dateTime"
          :options="defaultOptions3"
          class="bg-light rounded p-1 mt-1"
        />
      </CRow>

      <!-- ------------------------------------------- نمودار -->
      <!-- <CRow class="bg-gray-700 m-2 p-1 rounded" style="direction: rtl">
        <h5 class="text-center text-dark">اطلاعات آماری</h5>

        <CChartBar :datasets="defaultDatasets" labels="months" />

        <CChartLine :datasets="defaultDatasets2" labels="months" class="mt-3" />
      </CRow> -->
    </CCol>

    <!-- --------------------------------------------------------------------------------- map-->

    <CCol class="m-0 p-0">
      <l-map
        :zoom="zoom"
        :center="center"
        style="font-family: IRANSans"
        ref="map"
      >
        <!-- <l-control-layers position="topright"></l-control-layers> -->

        <!-- <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer> -->
        <l-control-layers position="bottomleft"></l-control-layers>
        <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
        />
        <!-- <l-draw-toolbar position="toplright"/> -->
        <!-- <l-freedraw v-model="polygons" :mode="mode" /> -->
        <l-control
          position="topright"
          class="align-items-center justify-content-center"
        >
          <CRow class="px-0 col-12">
            <CCol
              class="mx-1 align-items-center justify-content-center col-2 mt-1"
            >
              <CButton @click="clickHandler" class="m-0 p-1 btn btn-dark">
                <span class="align-self-center justify-content-center"
                  ><CIcon name="cil-diamond" size="lg" class="text-danger"
                /></span>
                مدیریت داده
              </CButton>
            </CCol>
            <CCol class="col-9">
              <CRow>
                <date-picker
                  class="col-sm-6 col-md-4 mt-1 p-0"
                  placeholder="تاریخ..."
                  v-model="searchItem.date"
                  :value="searchItem.date"
                  style="opacity: 0.8"
                ></date-picker>

                <vue-clock-picker
                  class="col-6 col-sm-3 col-md-3 mt-1 p-0"
                  placeholder="از ساعت..."
                  v-model="searchItem.fromTime"
                  :value="searchItem.fromTime"
                  style="opacity: 0.8"
                >
                </vue-clock-picker>

                <vue-clock-picker
                  class="col-6 col-sm-3 col-md-3 mt-1 p-0"
                  placeholder="تا ساعت..."
                  v-model="searchItem.toTime"
                  :value="searchItem.toTime"
                  style="opacity: 0.8"
                >
                </vue-clock-picker>

                <CButton
                  @click="search()"
                  class="col-12 col-sm-6 col-md-1 mt-1 btn-primary"
                  ><CIcon
                    name="cil-paper-plane"
                    class="text-light align-self-center"
                /></CButton>
                <CButton
                  @click="clear()"
                  class="col-12 col-sm-6 col-md-1 mt-1 btn-danger"
                  ><CIcon
                    name="cil-loop-circular"
                    class="text-light align-self-center"
                /></CButton>
              </CRow>
              <CRow>
                <CAlert
                  :show.sync="dismissCountDown"
                  closeButton
                  color="warning"
                  fade
                >
                  <strong class="rounded-circle mx-2 text-info">{{
                    dismissCountDown
                  }}</strong>
                  {{ alertText }}
                </CAlert>
              </CRow>
            </CCol>
            <!-- large chart modal -->
            <CModal title="نمودار" :show.sync="showModal" size="xl">
              <CRow
                class="bg-gray-700 m-2 p-1 rounded"
                style="direction: rtl; height = 250px"
              >
                <h5 class="text-center text-light">
                  {{
                    whichChart == "dis/gas"
                      ? "نمودار مسافت/سوخت"
                      : this.polylineTemp[0].date.substring(0, 11)
                      ? "نمودار سرعت " +
                        this.polylineTemp[0].date.substring(0, 11)
                      : "نمودار سرعت "
                  }}
                </h5>

                <CChartBar
                  v-if="whichChart == 'dis/gas'"
                  :datasets="defaultDatasets"
                  :options="defaultOptionsModal"
                  :labels="month"
                  class="bg-light rounded p-1"
                />

                <CChartLine
                  v-else
                  :datasets="defaultDatasets2"
                  :labels="dateTime"
                  :options="defaultOptionsModal2"
                  class="bg-light rounded p-1"
                />

                <!-- <CChartLine :datasets="defaultDatasets2" labels="months" class="mt-3" /> -->
              </CRow>

              <template #footer>
                <CButton
                  @click="showModal = false"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" />تایید
                </CButton>
                <CButton
                  @click="
                    showModal = false;
                    reportPage(
                      'speedChart',
                      speedDateTime,
                      polylineTemp[0].date.substring(0, 11)
                    );
                  "
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-print" />چاپ
                </CButton>
              </template>
            </CModal>

            <!-- report modal -->
            <CModal title="گزارش" :show.sync="reportModal" size="xl">
              <CRow>
                <CButton
                  @click="whichRequestedReport = 'distance'"
                  color="primary"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  >گزارش مسافت</CButton
                >
                <CButton
                  @click="whichRequestedReport = 'speed'"
                  color="primary"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  >گزارش سرعت</CButton
                >
                <CButton
                  @click="whichRequestedReport = 'fuel'"
                  color="primary"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  >گزارش سوخت</CButton
                >
              </CRow>
              <CRow
                class="m-2 rounded border border-2"
                style="direction: rtl; height = 250px"
              >
                <h5
                  class="
                    text-center text-light
                    bg-gray-700
                    rounded
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  style="height: 40px"
                >
                  {{
                    whichRequestedReport == "distance"
                      ? "گزارش مسافت"
                      : whichRequestedReport == "speed"
                      ? "گزارش سرعت"
                      : "گزارش سوخت"
                  }}
                </h5>
                <!-- ***************************************************************** distance report -->
                <div v-if="whichRequestedReport == 'distance'">
                  <br />
                  <h5 class="text-primary mb-3">روزانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="dailyDistanceReport.fromDate"
                      :value="dailyDistanceReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="dailyDistanceReport.toDate"
                      :value="dailyDistanceReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getDistanceReport('daily')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearDailyDistanceReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>

                  <br />
                  <h5 class="text-primary mb-3 mt-3">ماهانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="monthlyDistanceReport.fromDate"
                      :value="monthlyDistanceReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="monthlyDistanceReport.toDate"
                      :value="monthlyDistanceReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getDistanceReport('monthly')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearMonthlyDistanceReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>

                  <br />
                  <h5 class="text-primary mb-3 mt-3">سالانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="yearlyDistanceReport.fromDate"
                      :value="yearlyDistanceReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="yearlyDistanceReport.toDate"
                      :value="yearlyDistanceReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getDistanceReport('yearly')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearyearlyDistanceReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>
                </div>

                <!-- ***************************************************************** speed report -->
                <div v-else-if="whichRequestedReport == 'speed'">
                  <br />
                  <h5 class="text-primary mb-3">روزانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تاریخ..."
                      v-model="dailySpeedReport.fromDate"
                      :value="dailySpeedReport.fromDate"
                    ></date-picker>

                    <vue-clock-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از ساعت..."
                      v-model="dailySpeedReport.fromTime"
                      :value="dailySpeedReport.fromTime"
                    >
                    </vue-clock-picker>

                    <vue-clock-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا ساعت..."
                      v-model="dailySpeedReport.toTime"
                      :value="dailySpeedReport.toTime"
                    >
                    </vue-clock-picker>
                    <CRow class="justify-content-end mt-4">
                      <CButton
                        @click="getSpeedReport('daily')"
                        class="btn-warning col-12 col-sm-6 col-md-2"
                        ><CIcon
                          name="cil-print"
                          class="text-dark align-self-center"
                      /></CButton>
                      <CButton
                        @click="clearDailySpeedReport()"
                        class="btn-danger col-12 col-sm-6 col-md-2"
                        ><CIcon
                          name="cil-loop-circular"
                          class="text-light align-self-center"
                        />
                      </CButton>
                    </CRow>
                  </CRow>

                  <br />
                  <h5 class="text-primary mb-3 mt-3">تخطی از سرعت مجاز</h5>
                  <hr />

                  <CRow class="mt-2 mb-3">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="exceedSpeedReport.fromDate"
                      :value="exceedSpeedReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="exceedSpeedReport.toDate"
                      :value="exceedSpeedReport.toDate"
                    ></date-picker>

                    <CInput
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="(Km/h) سرعت مجاز"
                      v-model="exceedSpeedReport.speed"
                      :value="exceedSpeedReport.speed"
                      type="number"
                    ></CInput>
                    <CRow class="justify-content-end mt-2">
                      <CButton
                        @click="getSpeedReport('exceed')"
                        class="btn-warning col-12 col-sm-6 col-md-2"
                        ><CIcon
                          name="cil-print"
                          class="text-dark align-self-center"
                      /></CButton>
                      <CButton
                        @click="clearExceedSpeedReport()"
                        class="btn-danger col-12 col-sm-6 col-md-2"
                        ><CIcon
                          name="cil-loop-circular"
                          class="text-light align-self-center"
                        />
                      </CButton>
                    </CRow>
                  </CRow>
                </div>

                <!-- ***************************************************************** fuel consumption report -->
                <div v-else-if="whichRequestedReport == 'fuel'">
                  <br />
                  <h5 class="text-primary mb-3">روزانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="dailyFuelReport.fromDate"
                      :value="dailyFuelReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="dailyFuelReport.toDate"
                      :value="dailyFuelReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getFuelReport('daily')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearDailyFuelReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>

                  <br />
                  <h5 class="text-primary mb-3 mt-3">ماهانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="monthlyFuelReport.fromDate"
                      :value="monthlyFuelReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="monthlyFuelReport.toDate"
                      :value="monthlyFuelReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getFuelReport('monthly')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearMonthlyFuelReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>

                  <br />
                  <h5 class="text-primary mb-3 mt-3">سالانه</h5>
                  <hr />

                  <CRow class="mt-2">
                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="از تاریخ..."
                      v-model="yearlyFuelReport.fromDate"
                      :value="yearlyFuelReport.fromDate"
                    ></date-picker>

                    <date-picker
                      class="col-sm-12 col-md-6 col-lg-4 mt-2"
                      placeholder="تا تاریخ..."
                      v-model="yearlyFuelReport.toDate"
                      :value="yearlyFuelReport.toDate"
                    ></date-picker>

                    <CButton
                      @click="getFuelReport('yearly')"
                      class="mt-2 btn-warning col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-print"
                        class="text-dark align-self-center"
                    /></CButton>
                    <CButton
                      @click="clearYearlyFuelReport()"
                      class="mt-2 btn-danger col-12 col-sm-6 col-md-2"
                      ><CIcon
                        name="cil-loop-circular"
                        class="text-light align-self-center"
                      />
                    </CButton>
                  </CRow>
                </div>
              </CRow>

              <template #footer>
                <CButton
                  @click="reportModal = false"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" />بستن
                </CButton>
              </template>
            </CModal>
          </CRow>
        </l-control>

        <l-marker-cluster>
          <l-marker
            v-for="(item, index) in stops"
            :key="'marker-' + index"
            :lat-lng="item.point"
          >
            <l-tooltip>
              <div dir="ltr">
                <div>
                  <div class="card m-0 border-info rounded">
                    <div class="px-2 pt-3">
                      <div class="d-flex flex-row align-items-center">
                        <div class="pl-4">
                          <h4>{{ info.carName }}</h4>

                          <h6 class="text-muted" style="direction: rtl">
                            <CIcon name="cif-ir" width="20" />
                            {{ info.carPlate.substring(6) }}
                            {{ info.carPlate.substring(3, 6) }}
                            {{ info.carPlate.substring(2, 3) }}
                            {{ info.carPlate.substring(0, 2) }}
                          </h6>
                          <h6 class="text-muted">
                            {{ info.driverName }}
                            <CIcon
                              name="cil-user"
                              size="lg"
                              class="text-info"
                            />
                          </h6>
                        </div>
                        <div class="ml-2">
                          <img
                            :src="info.carImage"
                            alt="user"
                            class="rounded-circle"
                            width="100px"
                            height="100px"
                          />
                        </div>
                      </div>

                      <div class="mt-4">
                        <p style="text-align: center">
                          {{
                            item.dateTime.length == 0 ? "---" : item.dateTime
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </l-tooltip>
            <l-icon>
              <img src="../../../public/img/carlocation_sm_b.png" />
            </l-icon>
          </l-marker>
        </l-marker-cluster>

        <l-marker v-if="startPath.length > 0" :lat-lng="startPath">
          <l-icon><img src="../../../public/img/start.png" /> </l-icon>
        </l-marker>

        <l-polyline :lat-lngs="polyline.latlngs"></l-polyline>

        <!-- <l-moving-marker
          :lat-lng="locations[0].latlng"
          :duration="duration"
          :icon="icon"
        >
          <l-popup :content="l.text" />
        </l-moving-marker> -->

        <!-- <l-polyline-offset :lat-lngs="polyline.latlngs" :offset="3" color="red" /> -->

        <l-marker
          v-for="(item, index) in polylineTemp"
          :key="index"
          :lat-lng="[item.latitude, item.longitude]"
        >
          <l-tooltip>
            <div dir="ltr">
              <div>
                <div class="card m-0 border-info rounded">
                  <div class="px-2 pt-3">
                    <div class="d-flex flex-row align-items-center">
                      <div class="pl-4">
                        <h4>{{ info.carName }}</h4>
                        <h6 class="text-muted" style="direction: rtl">
                          <CIcon name="cif-ir" width="20" />
                          {{ info.carPlate.substring(6) }}
                          {{ info.carPlate.substring(3, 6) }}
                          {{ info.carPlate.substring(2, 3) }}
                          {{ info.carPlate.substring(0, 2) }}
                        </h6>
                        <h6 class="text-muted">
                          {{ info.driverName }}
                          <CIcon name="cil-user" size="lg" class="text-info" />
                        </h6>
                      </div>
                      <div class="ml-2">
                        <img
                          :src="info.carImage"
                          alt="user"
                          class="rounded-circle"
                          width="100px"
                          height="100px"
                        />
                      </div>
                    </div>
                    <div class="row mt-4">
                      <!-- <div class="col border-right text-center">
                        <h6 class="font-light">
                          {{ item.signalPower.length == 0 ? "---" : item.signalPower[0].sensorValue }} %
                        </h6>
                        <CIcon
                          name="cil-signal-cellular-3"
                          size="lg"
                          class="text-success"
                        />
                      </div>
                      <div class="col border-right text-center">
                        <h6 class="font-light">
                          {{ item.simCardBalance.length == 0 ? "---" : item.simCardBalance[0].sensorValue }}
                        </h6>
                        ریال                        
                        <CIcon
                          name="cil-money"
                          size="lg"
                          class="text-success"
                        />
                      </div> -->
                      <div class="col border-right text-center">
                        <h6 class="font-light">
                          {{ item.speed }}
                        </h6>
                        Km/h
                        <CIcon
                          name="cil-speedometer"
                          size="lg"
                          class="text-success"
                        />
                      </div>
                      <!-- <div class="col text-center">
                        <h6 class="font-light">
                          {{ item.powerState.length == 0 ? "---" : item.powerState[0].sensorValue }}
                        </h6>
                        <CIcon
                          name="cil-input-power"
                          size="lg"
                          class="text-success"
                        />
                      </div> -->
                    </div>
                    <div class="mt-4">
                      <p style="text-align: center">
                        {{ item.date.length == 0 ? "---" : item.date }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </l-tooltip>
          <l-icon>. </l-icon>
        </l-marker>

        <l-polygon
          v-for="(polygons, i) in polygons"
          :key="'marker-' + i"
          :lat-lngs="polygons.points"
          :color="polygons.color"
        ></l-polygon>
      </l-map>
    </CCol>
  </CRow>

  <CModal v-else
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف ماشین'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف ماشین'"
          @click="deletecar"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
</template>

<script>
import L from "leaflet";
import Vue from "vue";
// import LDrawToolbar from 'vue2-leaflet-draw-toolbar';
import LFreeDraw from "vue2-leaflet-freedraw";
import { NONE, ALL } from "leaflet-freedraw";
import axios from "axios";
import { Values } from "../../commonValues";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import { CChartBar, CChartLine } from "@coreui/vue-chartjs";

Vue.component("l-marker-cluster", Vue2LeafletMarkerCluster);
// Vue.component('l-draw-toolbar', LDrawToolbar);
Vue.component("l-freedraw", LFreeDraw);

import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LPolyline,
  LControlLayers,
  LIcon,
  LControl,
  LPolygon,
  LImageOverlay,
  LGeoJson,
} from "vue2-leaflet";
// import vue2leafletdrawtoolbar from "vue2-leaflet-draw-toolbar";

import { Icon } from "leaflet";
import { parse } from "@babel/core";
import router from "../../router";

import LPolylineOffset from "vue2-leaflet-polylineoffset";

import LMovingMarker from "./lib/index.vue";
Vue.component("l-moving-marker", LMovingMarker);
function rand(n) {
  const max = n + 0.01;
  const min = n - 0.01;
  return Math.random() * (max - min) + min;
}

const locations = [];
for (let i = 0; i < 1; i++) {
  locations.push({
    id: i,
    latlng: [48.8929425, 2.3821873],
    text: "Moving Marker #" + i,
  });
}

const icon = L.icon({
  iconUrl:
    "https://s3-eu-west-1.amazonaws.com/ct-documents/emails/A-static.png",
  iconSize: [21, 31],
  iconAnchor: [10.5, 31],
  popupAnchor: [4, -25],
});

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "leafLeft",
  props: ["carInfo"],
  // props: {
  //   duration: { type: Number, default: 200 },
  //   keepAtCenter: { type: Boolean, default: true },
  // },

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolyline,
    LControlLayers,
    LIcon,
    LControl,
    datePicker: VuePersianDatetimePicker,
    VueClockPicker,
    CChartBar,
    CChartLine,
    LPolygon,
    LImageOverlay,
    LGeoJson,
    LPolylineOffset,
  },

  // watch: {
  //   duration: {

  //     handler(value, oldValue) {
  //       if (value !== oldValue) {
  //         clearInterval(this.interval);
  //         let j=0;
  //         const setRandomLatLng = () => {
  //           this.locations.forEach((location) => {
  //             if (this.polylineTemp.length > 0 && j<this.polylineTemp.length)
  //             location.latlng = [
  //                 this.polylineTemp[j].latitude,
  //                 this.polylineTemp[j].longitude,
  //               ];
  //               j++;

  //           });
  //         };

  //         this.interval = setInterval(() => {
  //            setRandomLatLng();}
  //         , 50);
  //         setRandomLatLng();
  //       }
  //     },
  //     immediate: true,
  //   },
  // },

  data() {
    return {
      // duration: { type: Number, default: 2000 },
      // keepAtCenter: { type: Boolean, default: false },
      locations,
      icon,
      interval: null,

      serverIp: Values.serverIp,

      //url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      //url: "http://192.168.71.189:1010/map/iran/{z}/{x}/{y}.png",

      tileProviders: [
        {
          name: "OpenStreetMap",
          visible: false,
          // attribution:
          //   '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          // url: "http://192.168.71.189:1010/map/iran/{z}/{x}/{y}.png",
        },
        {
          name: "OfflineMap",
          visible: true,
          url: Values.serverIp + "map/iran/{z}/{x}/{y}.png",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "OpenTopoMap",
          visible: false,
          url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleRoadmap",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleTerrain",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleAlteredRoadmap",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleSatellite",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
      ],

      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      center: [33.504, 51.26],

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      showCarTracking:true,

      //center: Values.latlngs[0],
      markerLatLng: [34.504, 48.26],
      markerLatLng2: [34.104, 48.11],
      stops: [],
      startPath: [],
      polylineTemp: {},
      polyline: {
        latlngs: [
          // [34.504, 50.26],
          // [34.104, 51.11],
          // [35.504, 52.26],
          // [36.104, 53.11],
          // [37.504, 54.26],
          // [38.104, 55.11],
          // [39.504, 56.26],
          // [40.104, 57.11],
          // [34.504, 58.26],
          // [34.104, 58.11],
          // [35.504, 58.26],
          // [36.104, 58.11],
          // [37.504, 58.26],
          // [38.104, 58.11],
          // [39.504, 58.26],
          // [40.104, 58.11],
          // [44.504, 59.26],
          // [44.104, 59.11],
          // [45.504, 59.26],
          // [46.104, 59.11],
          // [47.504, 60.26],
          // [48.104, 60.11],
          // [49.504, 60.26],
          // [40.104, 60.11],
        ],
        color: "green",
      },

      polygon: {},

      clusterOptions: {
        disableClusteringAtZoom: 18,
        chunkedLoading: true,
      },

      polygons: [],
      isActive: false,

      showStatistics: false,

      info: {
        carName:
          this.$route.params.carInfo.carName.length == 0
            ? "---"
            : this.$route.params.carInfo.carName,
        carPlate:
          this.$route.params.carInfo.registrationPlate.length == 0
            ? "---"
            : this.$route.params.carInfo.registrationPlate,
        driverName:
          this.$route.params.carInfo.driverName.length == 0
            ? "---"
            : this.$route.params.carInfo.driverName.toString(),
        dateTime:
          this.$route.params.carInfo.lastLocationDateTime.length == 0
            ? "---"
            : this.$route.params.carInfo.lastLocationDateTime,
        stop: false,
        limits: false,
        powerState:
          this.$route.params.carInfo.powerState.length == 0
            ? "---"
            : this.$route.params.carInfo.powerState[0].sensorValue,
        battery:
          this.$route.params.carInfo.battery.length == 0
            ? "---"
            : this.$route.params.carInfo.battery[0].sensorValue,
        poe: "ندارد",
        simCardPresence:
          this.$route.params.carInfo.simCardPresence.length == 0
            ? "---"
            : this.$route.params.carInfo.simCardPresence[0].sensorValue,
        signalPower:
          this.$route.params.carInfo.signalPower.length == 0
            ? "---"
            : this.$route.params.carInfo.signalPower[0].sensorValue,
        SimcardBalance:
          this.$route.params.carInfo.simCardBalance.length == 0
            ? "---"
            : this.$route.params.carInfo.simCardBalance[0].sensorValue,
        networkType:
          this.$route.params.carInfo.networkType.length == 0
            ? "---"
            : this.$route.params.carInfo.networkType[0].sensorValue,

        carImage:
          this.$route.params.carInfo.carImage.length == 0
            ? "https://mdbootstrap.com/img/Photos/Horizontal/Nature/full page/img(11).jpg"
            : Values.serverIp + this.$route.params.carInfo.carImage,
      },

      searchItem: {
        date: "",
        fromTime: "",
        toTime: "",
      },

      dismissCountDown: 0,
      alertText: "",
      month: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      showModal: false,
      speed: [],
      dateTime: [],
      whichChart: "dis/gas",
      speedDateTime: [],

      reportModal: false,
      whichRequestedReport: "",
      dailyDistanceReport: {
        fromDate: "",
        toDate: "",
      },
      monthlyDistanceReport: {
        fromDate: "",
        toDate: "",
      },
      yearlyDistanceReport: {
        fromDate: "",
        toDate: "",
      },

      dailySpeedReport: { fromDate: "", fromTime: "", toTime: "" },
      exceedSpeedReport: { fromDate: "", toDate: "", speed: "" },
      dailyFuelReport: { fromDate: "", toDate: "" },
      monthlyFuelReport: { fromDate: "", toDate: "" },
      yearlyFuelReport: { fromDate: "", toDate: "" },
    };
  },

  computed: {
    mode() {
      return this.isActive ? ALL : NONE;
    },
    defaultDatasets() {
      return [
        {
          label: "مسافت در ماه (Km) ",
          backgroundColor: "#00ff00",
          // data: [
          //   1400, 2000, 1784, 3900, 1985, 1863, 1754, 1550, 1200, 1360, 1300,
          //   1600,
          // ],
          color: "rgb(255, 255, 255)",
        },
        {
          label: "سوخت در ماه (لیتر) ",
          backgroundColor: "#0000ff",
          // data: [86, 120, 42, 234, 110, 240, 139, 180, 140, 120, 112, 111],
          color: "rgb(255, 255, 255)",
        },
      ];
    },
    defaultOptions() {
      return {
        // scales: {
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        aspectRatio: 1.35,
        title: {
          display: true,
          text: "سوخت/مسافت",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "rgb(255, 255, 255)",
          },
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              // ticks: {
              //   // Include a dollar sign in the ticks
              //   callback: function (value, index, values) {
              //     return value + " $ ";
              //   },
              // },
            },
          ],
        },
      };
    },
    defaultOptions3() {
      return {
        // scales: {
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        aspectRatio: 1.35,
        title: {
          display: true,
          text: "سرعت",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "rgb(255, 255, 255)",
          },
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              // ticks: {
              //   // Include a dollar sign in the ticks
              //   callback: function (value, index, values) {
              //     return value + " $ ";
              //   },
              // },
            },
          ],
        },
      };
    },
    defaultOptionsModal() {
      return {
        // scales: {
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        //aspectRatio: 1.35,
        title: {
          display: false,
          text: "سوخت/مسافت",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "rgb(255, 255, 255)",
          },
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              // ticks: {
              //   // Include a dollar sign in the ticks
              //   callback: function (value, index, values) {
              //     return value + " $ ";
              //   },
              // },
            },
          ],
        },
      };
    },
    defaultOptionsModal2() {
      return {
        // scales: {
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        //aspectRatio: 1.35,
        title: {
          display: false,
          text: "ُسرعت (Km/h)",
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "rgb(255, 255, 255)",
          },
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              // ticks: {
              //   // Include a dollar sign in the ticks
              //   callback: function (value, index, values) {
              //     return value + " $ ";
              //   },
              // },
            },
          ],
        },
      };
    },
    defaultDatasets2() {
      return [
        {
          label: "سرعت (Km/h)",
          backgroundColor: "rgb(228,102,81,0.9)",
          data: this.speed,
        },
        // {
        //   label: "رطوبت",
        //   backgroundColor: "rgb(0,216,255,0.9)",
        //   data: [39, 80, 40, 35, 40, 20, 45],
        // },
      ];
    },
  },
  methods: {
    // duration: {
    //   handler(value, oldValue) {
    //     if (value !== oldValue) {
    //       clearInterval(this.interval);
    //       const setRandomLatLng = () => {
    //         this.locations.forEach((location) => {
    //           location.latlng = L.latLng(rand(48.8929425), rand(2.3821873));
    //         });
    //       };
    //       this.interval = setInterval(() => {
    //         setRandomLatLng();
    //       }, value);
    //       setRandomLatLng();
    //     }
    //   },
    //   immediate: true,
    // },

    flipActive() {
      this.isActive = !this.isActive;
    },

    clickHandler() {
      this.showStatistics = !this.showStatistics;
    },

    setStop(event) {
      if (event.target.checked) {
        //************************** receive data */
        axios
          .post(Values.serverIp + "LocationHistory/GetLocationStatus", {
            carId: this.$route.params.carInfo.carId,
            date: this.searchItem.date,
            fromTime: this.searchItem.fromTime,
            toTime: this.searchItem.toTime,
          })
          .then((response) => {
            if (response.status == 200) {
              this.stops = response.data;
              //console.log(response.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        // this.stops = [
        //   { point: [34.504, 48.26], name: "nasser" },
        //   { point: [34.104, 48.11], name: "hamid" },
        //   { point: [35.504, 47.26], name: "alireza" },
        //   { point: [36.104, 46.11], name: "amir" },
        //   { point: [34.504, 58.26], name: "saeed" },
        //   { point: [34.104, 58.11], name: "nasser" },
        //   { point: [35.504, 57.26], name: "nasser" },
        //   { point: [36.104, 56.11], name: "nasser" },
        // ];
      } else {
        this.stops = [];
      }
    },

    setLimits(event) {
      if (event.target.checked) {
        const config = { headers: { "Content-Type": "application/json" } };
        axios
          .post(
            Values.serverIp + "LocationHistory/GetCarPositionPermission",
            JSON.stringify(this.$route.params.carInfo.carId),
            config
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.polygons = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
        // this.polygons = [
        //   {
        //     latlngs: [
        //       [33.2263299, 46.6222],
        //       [33.1969435, 50.6136169],
        //       [37.18527929999999, 50.6143036],
        //       [37.21024000000001, 46.6270065],
        //     ],
        //     color: "red",
        //   },
        //   {
        //     latlngs: [
        //       [37.2263299, 53.6222],
        //       [38.21024000000001, 54.6270065],
        //       [37.1969435, 54.6136169],
        //       [38.18527929999999, 53.6143036],
        //     ],
        //     color: "green",
        //   },
        // ];
      } else {
        this.polygons = {};
      }
    },

    async myLoop(data, time, size, center) {
      let index = 0;
      if (size <= 250) index = 5;
      else if (size <= 500) index = 10;
      else if (size <= 1000) index = 25;
      else if (size <= 1500) index = 50;
      else if (size <= 2000) index = 100;
      else index = 125;

      for (let i = 0; i < size - (size % index); i = i + index) {
        for (let j = 0; j < index; j = j + 1)
          data.push([center[i + j].latitude, center[i + j].longitude]);
        // data.push([center[i + 1].latitude, center[i + 1].longitude]);
        // data.push([center[i + 2].latitude, center[i + 2].longitude]);
        // data.push([center[i + 3].latitude, center[i + 3].longitude]);
        // data.push([center[i + 4].latitude, center[i + 4].longitude]);
        // data.push([center[i + 5].latitude, center[i + 5].longitude]);
        // data.push([center[i + 6].latitude, center[i + 6].longitude]);
        // data.push([center[i + 7].latitude, center[i + 7].longitude]);
        // data.push([center[i + 8].latitude, center[i + 8].longitude]);
        // data.push([center[i + 9].latitude, center[i + 9].longitude]);

        await this.sleep((time / size) * index);
        //this.center = data[data.length - 1];

        // interval = setInterval(function() { data.push([center[i].latitude, center[i].longitude]);
        // data.push([center[i + 1].latitude, center[i + 1].longitude]);
        // data.push([center[i + 2].latitude, center[i + 2].longitude]);
        // data.push([center[i + 3].latitude, center[i + 3].longitude]);
        // data.push([center[i + 4].latitude, center[i + 4].longitude]);
        // data.push([center[i + 5].latitude, center[i + 5].longitude]);
        // data.push([center[i + 6].latitude, center[i + 6].longitude]);
        // data.push([center[i + 7].latitude, center[i + 7].longitude]);
        // data.push([center[i + 8].latitude, center[i + 8].longitude]);
        // data.push([center[i + 9].latitude, center[i + 9].longitude]);}, (time/size)*10);
      }

      for (let i = size - (size % index); i < size; i = i + 1) {
        data.push([center[i].latitude, center[i].longitude]);
      }

      // var line = L.polyline(data, { snakingSpeed: 200 });
      // line.addTo(this.$refs.map).snakeIn();

      // var route = L.layerGroup(
      //   [

      //     L.polyline(data),

      //   ],
      //   { snakingPause: 200 }
      // );
      // route.addTo(this.$refs.map).snakeIn();
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms / 1000));
    },

    //****************************************************************** search */
    search() {
      if (
        this.searchItem.toTime < this.searchItem.fromTime &&
        this.searchItem.toTime != ""
      ) {
        this.dismissCountDown = 10;
        this.alertText = "ساعت پایان باید از ساعت شروع بزرگتر باشد.";
      } else {
        axios
          .post(Values.serverIp + "LocationHistory/GetLocationHistory", {
            carId: this.$route.params.carInfo.carId,
            date: this.searchItem.date,
            fromTime: this.searchItem.fromTime,
            toTime: this.searchItem.toTime,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data.length < 1) {
                this.dismissCountDown = 10;
                this.alertText = "برای تاریخ مورد نظر داده ای وجود ندارد.";
              }

              this.polyline.latlngs = [];
              this.polylineTemp = response.data;

              this.speed = [];
              this.dateTime = [];
              this.speedDateTime = [];

              for (let i = 0; i < this.polylineTemp.length; i++) {
                var temp = {};
                this.speed.push(this.polylineTemp[i].speed);
                this.dateTime.push(this.polylineTemp[i].date.substring(11));
                temp.y = this.polylineTemp[i].speed;
                temp.x = this.polylineTemp[i].date.substring(11);
                //console.log(temp);
                this.speedDateTime.push(temp);
              }

              //console.log(this.speedDateTime);

              this.startPath = [];
              this.startPath = [
                this.polylineTemp[0].latitude,
                this.polylineTemp[0].longitude,
              ];
              this.center = [
                this.polylineTemp[0].latitude,
                this.polylineTemp[0].longitude,
              ];
              this.myLoop(
                this.polyline.latlngs,
                5000,
                this.polylineTemp.length,
                this.polylineTemp
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //*********************************************************************** clear search form */
    clear() {
      this.searchItem.date = "";
      this.searchItem.fromTime = "";
      this.searchItem.toTime = "";
    },

    //*********************************************************************** show Large chart */
    largeChart(data) {
      this.showModal = true;
      this.whichChart = data;
    },

    //*********************** report page */
    reportPage(data, chartData, Date, sum) {
      // let routeData = this.$router.resolve({
      //   name: "JointReport",
      //   query: { whichReport: data, chartData: chartData, date: Date },
      // });
      // window.open(routeData.href, "_blank");

      router.push({
        name: "JointReport",
        params: { whichReport: data, chartData: chartData, date: Date, sum:sum },
      });
    },
    //******************************** clearDistanceReport */
    clearDailyDistanceReport() {
      this.dailyDistanceReport.fromDate = "";
      this.dailyDistanceReport.toDate = "";
    },
    //******************************** clearDistanceReport */
    clearMonthlyDistanceReport() {
      this.monthlyDistanceReport.fromDate = "";
      this.monthlyDistanceReport.toDate = "";
    },
    //******************************** clearDistanceReport */
    clearyearlyDistanceReport() {
      this.yearlyDistanceReport.fromDate = "";
      this.yearlyDistanceReport.toDate = "";
    },

    //******************************** clearDistanceReport */
    clearDailySpeedReport() {
      this.dailySpeedReport.fromDate = "";
      this.dailySpeedReport.fromTime = "";
      this.dailySpeedReport.toTime = "";
    },
    //******************************** clearDistanceReport */
    clearExceedSpeedReport() {
      this.exceedSpeedReport.fromDate = "";
      this.exceedSpeedReport.toDate = "";
      this.exceedSpeedReport.speed = "";
    },
    //******************************* clearDailyFuelReport */
    clearDailyFuelReport() {
      this.dailyFuelReport.fromDate = "";
      this.dailyFuelReport.toDate = "";
    },
    //******************************* clearMonthyFuelReport */
    clearMonthlyFuelReport() {
      this.monthlyFuelReport.fromDate = "";
      this.monthlyFuelReport.toDate = "";
    },
    //******************************* clearYearlyFuelReport */
    clearYearlyFuelReport(){
      this.yearlyFuelReport.fromDate = "";
      this.yearlyFuelReport.toDate = "";
    },
    // *************************************** get distance report
    getDistanceReport(data) {
      if (data == "daily") {
        axios
          .post(Values.serverIp + "Report/GetDailyDistance", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.dailyDistanceReport.fromDate,
            toDate: this.dailyDistanceReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "dailyDistance",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "monthly") {
        axios
          .post(Values.serverIp + "Report/GetMonthlyDistance", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.monthlyDistanceReport.fromDate,
            toDate: this.monthlyDistanceReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "monthlyDistance",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "yearly") {
        axios
          .post(Values.serverIp + "Report/GetYearlyDistance", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.yearlyDistanceReport.fromDate,
            toDate: this.yearlyDistanceReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "yearlyDistance",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    // *************************************** get speed report
    getSpeedReport(data) {
      if (data == "daily") {
        axios
          .post(Values.serverIp + "Report/GetOneDaySpeed", {
            carId: this.$route.params.carInfo.carId,
            Date: this.dailySpeedReport.fromDate,
            fromTime: this.dailySpeedReport.fromTime,
            toTime: this.dailySpeedReport.toTime,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "dailySpeed",
                response.data.reportList,
                response.data.dateTime
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "exceed") {
        axios
          .post(Values.serverIp + "Report/GetDailySpeeding", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.exceedSpeedReport.fromDate,
            toDate: this.exceedSpeedReport.toDate,
            SpeedLimit: JSON.parse(this.exceedSpeedReport.speed),
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "exceedSpeed",
                response.data.reportList,
                response.data.dateTime
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    // *************************************** get fuel consuption report
    getFuelReport(data) {
      if (data == "daily") {
        axios
          .post(Values.serverIp + "Report/GetDailyFuelConsumption", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.dailyFuelReport.fromDate,
            toDate: this.dailyFuelReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              this.reportPage(
                "dailyFuel",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum,response.data.litterSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "monthly") {
        axios
          .post(Values.serverIp + "Report/GetMonthlyFuelConsumption", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.monthlyFuelReport.fromDate,
            toDate: this.monthlyFuelReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "monthlyFuel",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum,response.data.litterSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (data == "yearly") {
        axios
          .post(Values.serverIp + "Report/GetYearlyFuelConsumption", {
            carId: this.$route.params.carInfo.carId,
            fromDate: this.yearlyFuelReport.fromDate,
            toDate: this.yearlyFuelReport.toDate,
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.reportPage(
                "yearlyFuel",
                response.data.reportList,
                response.data.dateTime,
                [response.data.totalDistanceSum,response.data.litterSum]
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },

  mounted() {
    //console.log(this.$route.params.carInfo.carId);

    //************************** receive data */
    axios
      .post(Values.serverIp + "LocationHistory/GetLocationHistory", {
        carId: this.$route.params.carInfo.carId,
        date: this.searchItem.date,
        fromTime: this.searchItem.fromTime,
        toTime: this.searchItem.toTime,
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length < 1) {
            this.dismissCountDown = 10;
            this.alertText = "برای تاریخ مورد نظر داده ای وجود ندارد.";
          }

          this.polylineTemp = response.data;

          //console.log(this.polylineTemp);

          for (let i = 0; i < this.polylineTemp.length; i++) {
            this.speed.push(this.polylineTemp[i].speed);
            this.dateTime.push(this.polylineTemp[i].date.substring(11));

            var temp = {};
            temp.y = this.polylineTemp[i].speed;
            temp.x = this.polylineTemp[i].date.substring(11);
            //console.log(temp);
            this.speedDateTime.push(temp);
          }

          this.startPath = [
            this.polylineTemp[0].latitude,
            this.polylineTemp[0].longitude,
          ];
          this.center = [
            this.polylineTemp[0].latitude,
            this.polylineTemp[0].longitude,
          ];

          this.myLoop(
            this.polyline.latlngs,
            5000,
            this.polylineTemp.length,
            this.polylineTemp
          );
        }
      })
     .catch((response) => {
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            this.showCarTracking=false,
            this.alertModal = true,
            this.showPage= false,
            this.alertModalTitle = "عدم مجوز",
            this.alertModalText ="شما دارای مجوز دسترسی به این قسمت نمی باشید.",
            this.alertModalColor = "info",
            this.alertModalButtonText = "تایید";
          } else if (response.response.status == 401) {  //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #00e676;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */
</style>

<style>
@import "~leaflet/dist/leaflet.css";
</style>
